export default {
  title: 'עמלות של הסוכן {1}',
};
